import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { ROUTES } from '#/config/routes';
import { fetchStockIssueDetail } from '#/api/imsMgmt/receipts/stockIssue/fetchDetail';
import { Button } from '#/modules/commonComponents/button';
import { cn } from '#/lib/utils';
import PageShell from '#/modules/infra/layout/PageShell';
import StockIssueBlock from '#/modules/imsMgmt/receipts/stockIssue/components/StockIssueBlock';
import { getStockIssueApiErrorMessage } from '#/modules/imsMgmt/receipts/stockIssue/helper/apiError';
import { stockIssueDetailQueryKey } from '#/utils/queryKeys';

const StockIssueDetailPage = () => {
  const { id } = useParams();

  const detailQuery = useQuery({
    queryKey: stockIssueDetailQueryKey(id),
    queryFn: () => fetchStockIssueDetail(id),
    enabled: Boolean(id),
  });

  const detail = detailQuery.data?.data;
  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div
            className={cn(
              'sticky top-0 z-20 -mx-1 flex flex-wrap items-center gap-2',
              'border-b border-slate-200 bg-canvas px-1 pb-3 pt-1',
            )}
          >
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">出庫單詳情</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.stockIssue}>返回列表</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getStockIssueApiErrorMessage(detailQuery.error, '載入出庫單失敗')}
            </p>
          ) : null}

          {detail ? (
            <StockIssueBlock
              detail={detail}
              defaultOpen
              showActions
              onRefetch={() => detailQuery.refetch()}
            />
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default StockIssueDetailPage;
